import { Fragment, useState, useEffect } from "react";

import AOS from 'aos';
import 'aos/dist/aos.css';


import LinesLeftActive from "./LinesLeftActive";
import LinesLeftInActive from "./LinesLeftInActive";
import LinesRightActive from "./LinesRightActive";
import LinesRightInActive from "./LinesRightInActive";
import TextLeftActive from "./TextLeftActive";
import TextLeftInActive from "./TextLeftInActive";
import TextRightActive from "./TextRightActive";
import TextRightInActive from "./TextRightInActive";

import gsap from "gsap";
import { useGSAP } from "@gsap/react";
import ScrollTrigger from "gsap/ScrollTrigger";
import { useRef } from "react";

const RoadMap = () => {

   useEffect(() => {
      AOS.init({
         // Optional settings, see AOS documentation for details
         // duration: 800,
         // once: true, // whether animation should happen only once - while scrolling down
      });
      AOS.refresh();
   }, []);

   const roadMap = [
      {

         monyr: '2025',
         qut: 'Q1',
         title: 'Foundation & platform Expansions',
         para: "RoutineSwap Launch – Fully decentralized, user-custodial exchange goes live for secure, seamless token swaps.Doplan Beta Release – Travel platform supporting Web3 payments for flights and hotel bookings with the lowest global rates.Billroutine Integration – Users can start paying for mobile recharges, electricity bills, tolls, and Grab/True Money top-ups using ROU.RTCbit Exchange Expansion – Support for spot trading, futures, margin trading, staking, and copy trading with 25+ networks.",
         status: true
      },
      {

         monyr: '2025',
         qut: 'Q2',
         title: 'Enhancing Crypto Utility & Adoption',
         para: "Doroutine Marketplace Launch - Decentralized eCommerce platform for global crypto-based buying and selling, contributing 20% of sales revenue to the ROU ecosystem. Roupay Prepaid Credit Card Rollout - Users can top up Roupay with ROU and spend in THB, USD, SGD, and EURO, earning cashback and reward points. Billroutine Service Expansion - More global utility providers onboarded for wider bill payment options. RoutineSwap Liquidity Boost- Incentive programs for liquidity providers, increasing decentralized trading efficiency.",
         status: true
      },
      {

         monyr: '2025',
         qut: 'Q3',
         title: 'DeFi & Financial Services Expansion',
         para: "RTCbit Lending & Borrowing Platform - Launch of crypto-backed loans, allowing users to borrow funds using ROU and other major assets as collateral. Routine Smart Mining Enhancement - Optimizing real-time token mining on every BEP-20 block for exclusive ROU members. Doplan Full-Scale Rollout- Adding more airlines, hotels, and travel service providers with Al-powered lowest price scanning from 180+ platforms. Doroutine Growth - Expanding merchant onboarding and enabling NFT-based digital goods marketplace.",
         status: true
      },
      {

         monyr: '2025',
         qut: 'Q4',
         title: 'Scaling & Global Adoption',
         para: "Roupay Premium Services - Exclusive lounge access, premium rewards, and crypto cashback enhancements for Roupay users. RTCbit Exchange Expansion - Integration of more trading pairs, lower fees, and Al-powered trading tools. RoutineSwap Governance Model - Introduction of a DAO-based governance system, allowing ROU holders to vote on protocol decisions. Mass Adoption Strategy - Collaborations with merchants, financial institutions, and global partners to drive real-world usage of ROU.",
         status: false
      },
      {

         monyr: '2025',
         qut: 'END',
         title: 'END OF 2025',
         para: "By the end of 2025, Routine Coin will have a fully operational crypto ecosystem that bridges DeFi, Web3 payments, eCommerce, travel, utility payments, and real-world spending solutions. With a focus on long-term sustainability and adoption, Routine Coin is set to redefine how crypto integrates into everyday life. Join us in revolutionizing the future of digital finance",
         status: false
      },


   ]


   const [viewMore, setViewMore] = useState(false);




 
   gsap.registerPlugin(useGSAP);
   gsap.registerPlugin(ScrollTrigger);


   useGSAP(() => {
     

   });

   return (

      <section className="RoadMapSec text-center" id="roadmap">
         <div className="container">
            <div className="CmnTeHd text-center ElearCmnHd">
               <h2 className="rdMpTx" data-aos='fade-left' data-aos-duration="1000"><span className="rdMpTx1 noHl">Road</span> <span className="rdMpTx2">map</span></h2>
            </div>
            <div className={`rdMpCht ${viewMore ? 'active' : ''}`}>
               {roadMap.map(({ numb, monyr, qut, title, para, status }, i) => {
                  return (
                     <Fragment key={numb}>
                        <div className={`rdMpChtR ${i % 2 == 0 ? 'lt' : 'rt'}`}>
                           <div className="rdMpChtTp" >
                              <div className={`rdMpChtCon ${i % 2 == 0 ? 'lt' : 'rt'} ${status ? 'active' : ""}`} data-aos={`${i % 2 == 0 ? 'fade-left' : 'fade-right'}`} data-aos-duration="500" data-aos-delay="100">
                                 {
                                    i % 2 == 0 ?
                                       <>
                                          {
                                             status ?
                                                <TextLeftActive quat={qut} />
                                                :
                                                <TextLeftInActive quat={qut} />                                                
                                          }
                                       </>
                                       :
                                       <>
                                          {
                                             status ?
                                                
                                                   <TextRightActive quat={qut} />
                                                
                                                :
                                                
                                                   <TextRightInActive quat={qut} />
                                                
                                          }
                                       </>
                                 }
                                 <div className="rdMpChtTx">
                                    <div className="rdMpChtTxYrTl">
                                       <div className="rdMpChtTxYr">
                                          {monyr}
                                       </div>
                                       <div className="rdMpChtTxTl">
                                          {title}
                                       </div>
                                       <p className="RdmapPara">{para}</p>
                                    </div>
                                 </div>
                              </div>
                           </div>
                           {
                              roadMap.length - 1 == i ? '' :
                                 <div className="rdMpChtR LineSvgBox" data-aos='fade-up' data-aos-duration="500" data-aos-delay="100">
                                    <div className={`rdMpChtBm ${i == 4 ? 'hdEl' : ''}`}>
                                       <div className="rdMpChtCrc">
                                          {
                                             i % 2 == 0 ?
                                                <>
                                                   {
                                                      status ?
                                                         <LinesLeftActive />
                                                         :
                                                         <LinesLeftInActive />
                                                   }
                                                </>
                                                :
                                                <>
                                                   {
                                                      status ?
                                                         <LinesRightActive />
                                                         :
                                                         <LinesRightInActive />
                                                   }
                                                </>
                                          }
                                       </div>
                                    </div>
                                 </div>
                           }
                        </div>

                        


                     </Fragment>
                  )
               })}
            </div>
            
         </div>
         <div className="CircleBlur Circle1"></div>
         <div className="CircleBlur Circle2"></div>
         <div className="CircleBlur Circle3"></div>
         <div className="CircleBlur Circle4"></div>
         <div className="CircleBlur Circle5"></div>

      </section>

   )
}
export default RoadMap;